import { mapActions } from 'vuex'
import { filterRulesMapped } from '@/tools/filterRules'


export default {
    name: 'AlertEventDialogExcludedRulesTabComponent',
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // headers
        tableHeaders: [],
        // reglas de filtrado
        tableFilterRules: {},
        // datos
        tableData: [],
        // key de los dato de la tabla
        tableDataKey: '_id',
        // botones del componente Tabla
        tableComponentButtons: []
    }),
    computed: {
    },
    created () {
    },
    mounted () {
        this.initialize()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        /**
         * Para inicializar el componente
         */
        initialize () {
            // cargo la tabla
            this.getData()
        },
        getData() {
            this.tableHeaders.cleanAndUpdate(this.model.tableHeaders)
            this.tableData.cleanAndUpdate(this.model.tableData)
            this.setTableFilterRules()
        },
        /**
         * Setea las reglas de filtrado
         */
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        }
    },
    watch: {
        'model.tableData':{
            deep: true,
            immediate: true,
            handler: function (newModel) {
                if(newModel) {
                    this.tableData.cleanAndUpdate(newModel)
                }
            }
        },
        'model.tableHeaders':{
            deep: true,
            immediate: true,
            handler: function (newModel) {
                if(JSON.stringify(newModel) !== JSON.stringify(this.tableHeaders)) {
                    this.tableHeaders.cleanAndUpdate(newModel)
                }
            }
        },
    }
}
